import { Component, OnDestroy, OnInit } from '@angular/core';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { CartService } from '@core/services/cart/cart.service';
import { StorageService } from '@core/services/util/storage.service';
import { ToastrService } from '@core/services/notification/toastr.service';
import { SessionStorageService } from '@core/services/util/session-storage.service';
import { NgClass } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FeatureToggleDirective } from '../../directives/feature-toggle.directive';

@Component({
    selector: 'app-rider-tip',
    templateUrl: './rider-tip.component.html',
    styleUrls: ['./rider-tip.component.scss'],
    standalone: true,
    imports: [FeatureToggleDirective, MatCheckboxModule, NgClass]
})

export class RiderTipComponent implements OnInit, OnDestroy {

    tipAmounts = [10, 20, 30, 50];
    selectedTip: number = 0;

    destroySubject$: Subject<void> = new Subject();

    constructor(
        private cartService: CartService,
        private storageService: StorageService,
        private toastrService: ToastrService,
        private sessionStorage: SessionStorageService
    ) {
    }

    ngOnInit() {
        this.cartService.serverCart
            .pipe(takeUntil(this.destroySubject$))
            .subscribe(data => {
                if (data && Object.keys(data).length && Object.keys(data.items).length) {
                    this.selectedTip = data.tip_amount;
                }
            });
    }

    ngOnDestroy(): void {
        this.destroySubject$.next();
        this.destroySubject$.complete();
    }

    addTip(tip_amount: number) {
        this.cartService.isCartChanged.next(true);
        this.sessionStorage.set('tip_amount', tip_amount);
        this.cartService.addTip(tip_amount).toPromise().then((data: any) => {
            this.cartService.hydrateServerCart(data.cart);
        }).catch((err) => {
            console.log('addTip', err);
            this.toastrService.openSnackBar('Something went wrong! Please try again!', 'OKAY');
        });
    }

    removeTip() {
        this.cartService.isCartChanged.next(true);
        this.sessionStorage.remove('tip_amount');
        this.cartService.removeTip().toPromise().then((data: any) => {
            this.cartService.hydrateServerCart(data.cart);
        }).catch((err) => {
            console.log('removeTip', err);
            this.toastrService.openSnackBar('Something went wrong! Please try again!', 'OKAY');
        });
    }

    isLoggedIn() {
        return !!(this.storageService.get('session-id') && this.storageService.get('phone_no'))
    }

    toggleTipAmount(tip, event) {
        if (!this.isLoggedIn()) {
            this.toastrService.openSnackBar('Please login to add tip for your rider', 'OKAY');
            return;
        }

        if (event.checked) {
            this.selectedTip = tip;
            this.addTip(tip);
        } else {
            this.selectedTip = 0;
            this.removeTip();
        }
    }
}
